module.exports = __webpack_public_path__ + "img/client-logo.864bc0c6.png";